(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('EsterniDeleteController',EsterniDeleteController);

    EsterniDeleteController.$inject = ['$uibModalInstance', 'entity', 'Esterni'];

    function EsterniDeleteController($uibModalInstance, entity, Esterni) {
        var vm = this;

        vm.esterni = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	Esterni.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
